import axios from './axiosInterceptors';

const API_URL = "/api/v1/";

const getUsers = () => {
    return axios.get(API_URL + `usermanager/Users`)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};

const getOperationTeam = (userId) => {
    return axios.get(API_URL + `usermanager/OperationTeam?userId=` + userId)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};

const getRole = (userId) => {
    return axios.get(API_URL + `usermanager/Role?userId=` + userId)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};

const saveUser = (role, team, user) => {
    return axios
        .post(API_URL + "usermanager/saveuser",
            { role, team, user }).then((response) => {
                return response.data;
            });
};
const deleteUser = (useId) => {
    return axios
        .delete(API_URL + `usermanager/DeleteUser/${useId}`)
            .then((response) => {
                return response.data;
            })
            .catch((err) => console.log("AXIOS ERROR: ", err))
};
const updatePassword = (userModel) => {
    return axios
        .put(API_URL + "usermanager/SetPassword", userModel)
        .then((response) => {
            return response.data
        })
        .catch((err) => console.log("AXIOS ERROR: ", err))
}

const allActions = {
    getUsers,
    getOperationTeam,
    getRole,
    saveUser,
    deleteUser,
    updatePassword,
};

export default allActions;